import moment from 'moment';

// Filters of Prospecção that survive a refresh (usePersistedFilters).
// The cadence and the display mode (funnel/table) live in the URL, so they are
// not stored here. One key for every cadence: the period and the search are
// not cadence-specific.
export var PROSPECTING_FILTERS_KEY = 'crm.prospeccao';

var DATE_INPUT_FORMATS = ['YYYY-MM-DD', 'YYYY-MM', 'YYYY'];

// Defaults depend on "today", so they are built at mount.
// `date` is the string DateNavigation emits: 'YYYY-MM-DD' in day mode,
// 'YYYY-MM' in month/year mode. It goes to the API as is.
export var getDefaultProspectingFilters = function() {
  return {
    date: moment().format('YYYY-MM-DD'),
    dateMode: 'day',
    search: '',
  };
};

// Date pill text: DD/MM/YYYY (day), MM/YYYY (month), YYYY (year).
export var formatProspectingDate = function(date, dateMode) {
  if (!date) return '';
  var m = moment(date, DATE_INPUT_FORMATS, true);
  if (!m.isValid()) return String(date);
  if (dateMode === 'year') return m.format('YYYY');
  if (dateMode === 'month') return m.format('MM/YYYY');
  return m.format('DD/MM/YYYY');
};

export var isProspectingPeriodDefault = function(filters, defaults) {
  return filters.date === defaults.date && filters.dateMode === defaults.dateMode;
};

// Badge: only what differs from the defaults. The period (date + mode) is one filter.
export var countActiveProspectingFilters = function(filters, defaults) {
  return (isProspectingPeriodDefault(filters, defaults) ? 0 : 1) +
    (filters.search ? 1 : 0);
};

// Query for actions.loadLeads.
export var getProspectingLeadsRequest = function(filters) {
  return { date: filters.date };
};

// Short text for RestoredFiltersNotice.
export var getProspectingRestoredSummary = function(filters, defaults) {
  var parts = [];
  if (!isProspectingPeriodDefault(filters, defaults)) {
    parts.push(formatProspectingDate(filters.date, filters.dateMode));
  }
  if (filters.search) parts.push('busca "' + filters.search + '"');
  return parts.join(', ');
};
